// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2Daqn","title":"Info_title__2GTJB","selects":"Info_selects__2jU8C","requiredAsterisk":"Info_requiredAsterisk__Q-1rf"};